/**
 * Provides a convinient way to pass attribute values from the html <div id="app"></div> element to the app.
 * e.g. <div id="app" data-theme="light"></div> will provide appDataset.theme = 'light'
 * See public/index.html
 */
import Vue from 'vue'
const mountEl = document.querySelector("#app");
let appDataset = {}
if (mountEl && mountEl.dataset)
{
  appDataset = mountEl.dataset
}
appDataset.theme = appDataset.theme ? appDataset.theme : 'dark'
appDataset.tenant = appDataset.tenant ? appDataset.tenant : 'default'
appDataset.commonAppAssetsBaseUrl = appDataset.commonAppAssetsBaseUrl ? appDataset.commonAppAssetsBaseUrl : 'https://d2f64mmirxruhh.cloudfront.net/app'


Vue.prototype.$appDataset = appDataset
export default appDataset
